<template>
  <div>
    <!-- 搜索框 -->
    <!-- <div class="search-container">
      <input
        v-model="searchKeyword"
        @keyup.enter="searchPlace"
        placeholder="输入地点名称"
      />
      <button @click="searchPlace">搜索</button>
    </div>
     -->
    <!-- 地图容器 -->
    <div id="container" />
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  name: "GaodeMap",
  props: {
    // 接收父组件传递的中心点坐标
    initialCenter: {
      type: Object,
      default: () => ({ lng: 118.054858, lat: 36.814114 })
    },
    data: {
      type: Object,
      default: () => ({
        head: {
          stateSign: '1' // 默认可编辑
        }
      })
    }
  },
  data() {
    return {
      map: null,
      AMap: null,
      searchKeyword: '',
      currentMarker: null,
      // 标记点坐标（兼容分开的经纬度格式）
      markerPosition: {
        lng: null,
        lat: null
      },
      mapInitialized: false
    }
  },
  computed: {
    // 是否处于锁定状态
    isLocked() {
      return this.data?.head?.stateSign === '2'
    }
  },
  watch: {
    // 深度监听父组件传入的中心点变化
    initialCenter: {
      deep: true,
      handler(newVal) {
        if (this.map && newVal && newVal.lat && newVal.lng) {
          const position = [parseFloat(newVal.lng), parseFloat(newVal.lat)]
          this.map.setCenter(position)
          this.createMarker(position)
        }
      }
    },
    // 监听锁定状态变化
    isLocked(newVal) {
      if (!this.mapInitialized || !this.map) return
      if (newVal) {
        // 锁定状态时，移除地图点击事件
        this.map.off('click', this.handleMapClick)
      } else {
        // 解锁状态时，重新添加地图点击事件
        this.map.on('click', this.handleMapClick)
      }
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      AMapLoader.load({
        key: "3fa18b9bc73319c29d767959cdb46c1f",
        version: "2.0",
        plugins: ['AMap.PlaceSearch', 'AMap.AutoComplete', 'AMap.Marker']
      }).then((AMap) => {
        this.AMap = AMap

        // 处理初始中心点（支持分开的经纬度格式）
        const initPosition = this.initialCenter.lat && this.initialCenter.lng
          ? [parseFloat(this.initialCenter.lng), parseFloat(this.initialCenter.lat)]
          : [118.054858, 36.814114]

        this.map = new AMap.Map("container", {
          zoom: 15,
          center: initPosition
        })
        // 标记地图已初始化
        this.mapInitialized = true
        // 添加地图点击事件（仅在非锁定状态）
        if (!this.isLocked) {
          this.map.on('click', this.handleMapClick)
        }
        // 如果父组件传入了初始中心点，添加标记
        if (this.initialCenter.lat && this.initialCenter.lng) {
          this.createMarker(initPosition)
        }

        // 添加地图点击事件
        this.map.on('click', this.handleMapClick)
      }).catch(e => {
        console.error("地图初始化失败", e)
      })
    },

    // 搜索地点
    searchPlace() {
      if (!this.searchKeyword.trim()) return

      const placeSearch = new this.AMap.PlaceSearch({
        map: this.map
      })

      placeSearch.search(this.searchKeyword, (status, result) => {
        if (status === 'complete' && result.poiList.pois.length) {
          const poi = result.poiList.pois[0]
          const position = [poi.location.lng, poi.location.lat]
          this.createMarker(position)
          this.map.setCenter(position)
        }
      })
    },

    // 处理地图点击事件
    handleMapClick(e) {
      this.createMarker([e.lnglat.lng, e.lnglat.lat])
    },

    // 创建标记点
    createMarker(position) {
      // 移除现有标记
      if (this.currentMarker) {
        this.map.remove(this.currentMarker)
      }

      // 创建新标记
      this.currentMarker = new this.AMap.Marker({
        position: position,
        map: this.map
      })

      // 更新标记点坐标（分开的经纬度格式）
      this.markerPosition = {
        lng: position[0],
        lat: position[1]
      }

      // 将坐标信息传递给父组件
      this.$emit('marker-position', this.markerPosition)

      // // 显示信息窗口
      // const infoWindow = new this.AMap.InfoWindow({
      //   content: `当前位置：${position[0].toFixed(6)}, ${position[1].toFixed(6)}`,
      //   offset: new this.AMap.Pixel(0, -30)
      // })
      // infoWindow.open(this.map, position)
    }
  }
}
</script>

<style>
#container {
  width: 80%;
  height: 400px;
  margin: 30px auto;
  /* border: 1px solid red; */
}

.search-container {
  text-align: center;
  margin: 20px auto;
  width: 80%;
}

.search-container input {
  padding: 8px 12px;
  width: 300px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.search-container button {
  padding: 8px 16px;
  margin-left: 10px;
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
